import template from './am-group-create.html';
class AmGroupCreateController {
  constructor($state, amGroupsService) {
    'ngInject';
    this.$state = $state;
    this.status = '';
    this.group = {};
    this.groupService = amGroupsService;
  }
  $onInit() { }
  $onChanges() { }
  $onDestroy() { }

  createGroup() {
    if (!this.group.name || !this.group.email) return;
    this.saveGroup();
  }

  saveGroup() {
    this.status = 'creating';
    // Call the service
    this.groupService
      .createGroup(this.group)
      .then(created => {
        this.createdGroup = created;
        this.status = 'success';
        this.$state.go('access-management.group-list');
      })
      .catch(() => {
        this.status = 'error';
      });
  }
}

export default {
  template,
  controller: AmGroupCreateController,
  controllerAs: 'groupCreateVm',
  bindings: {}
};
